<main>

  <div class="py-5 text-center">
    <h2>帳號移除紀錄</h2>
  </div>

  <div class="row g-5">

    <div class="col-12">
      <div class="list-group">
        <a class="list-group-item list-group-item-action"
          *ngFor="let request of requests | slice: (page-1) * pageSize : page * pageSize">
          <div class="d-flex">

            <div class="flex-grow-1 ms-3">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{request.profile.name}} ({{request.profile.uid}})</h5>
                <small>{{request.email ? request.email : "無電子郵件"}}</small>
              </div>
              <p class="mb-1">{{request.created.toMillis() | date:'yyyy/MM/dd h:mm:ss a'}}</p>
              <small class="text-muted">刪除原因: {{request.reason ? request.reason : "未提供原因"}}</small>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="col-12" *ngIf="requests.length > 0">
      <ngb-pagination class="d-flex justify-content-center" [collectionSize]="requests.length" [(page)]="page" [pageSize]="pageSize" [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="onPageChange(page)"></ngb-pagination>
    </div>

    <div class="col-12" *ngIf="requests.length == 0">
      <div class="py-5 text-center">
        <p>正在取得資料...</p>
      </div>
    </div>

  </div>

</main>
<footer class="my-5 pt-5 text-muted text-center text-small">
  <p class="mb-1">&copy; 2023 PATH LIFE Ltd.</p>
</footer>
